import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { File, FilePlus, Pdf } from 'react-feather';
import { useSearchParams } from "react-router-dom"
import { useAuthState } from "../../helper/Context/context";
import { Export_ExaminationForm_SelectAPI, GET_T_ExaminationForm_SelectAPI } from "../../helper/Redux/Slices/GridAPISlice";
import { LogoLoader } from "../../helper/Loaders/LogoLoader";
import { AdminHeader } from "./AdminHeader";
import { ExportStudentData } from "../Private/MainDashboard/MainContent/ExportStudentData";
import { Pegination } from "../../helper/Pegination/Pegination";

export const LicentiateCertificate = () => {

    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let paramName = searchParams.get("paramName")
    let m_MainSubjectID = searchParams.get("m_MainSubjectID")
    let m_SubSubjectID = searchParams.get("m_SubSubjectID")
    let optionalSub_M_IndicatorID = searchParams.get("optionalSub_M_IndicatorID")

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth } = userDetails
    const { UserID, token } = userDetails.user

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    useEffect(() => {
        handleGetData()
    }, [year?.Label, Month?.ID, To])

    const handleGetData = () => {
        const data = {
            M_FinancialYearID: year.Label != "Year ....." ? year.Label : '0',
            M_MonthID: Month.ID,
            T_ExaminationFormID: '0',
            M_MainSubjectID: m_MainSubjectID ? m_MainSubjectID : '0',
            M_SubSubjectID: m_SubSubjectID ? m_SubSubjectID : '0',
            OptionalSub_M_IndicatorID: optionalSub_M_IndicatorID ? optionalSub_M_IndicatorID : '0',
            Flag: 'Details',
            FromTop: From,
            ToTop: To,
            token: token,
            handleExcelData: handleExcelData
        }
        dispatch(GET_T_ExaminationForm_SelectAPI({ data }))
    }

    const { isLoading, TableData } = useSelector(state => state.GET_T_ExaminationForm_SelectData)


    const handleExcelData = () => {
        const data = {
            M_FinancialYearID: year.Label != "Year ....." ? year.Label : '0',
            M_MonthID: Month.ID,
            T_ExaminationFormID: '0',
            M_MainSubjectID: m_MainSubjectID ? m_MainSubjectID : '0',
            M_SubSubjectID: m_SubSubjectID ? m_SubSubjectID : '0',
            OptionalSub_M_IndicatorID: optionalSub_M_IndicatorID ? optionalSub_M_IndicatorID : '0',
            Flag: 'Details',
            FromTop: '1',
            ToTop: '99999',
            token: token
        }
        dispatch(Export_ExaminationForm_SelectAPI({ data }))
    }

    const { isExcelLoading, ExcelData } = useSelector(state => state.Export_ExaminationForm_SelectData)

    return (
        <>
            {isLoading && <LogoLoader />}
            <div className="row px-4 mt-5 mt-lg-0 pt-5 pt-lg-0" style={{ background: "#F2F2F2" }}>

                <AdminHeader />

                <div className="col-10 pt-5">
                    <h5 className="fw-bold pt-3 pb-2">{paramName ? paramName : '-'}</h5>
                </div>
                <div className="col-2 pt-5 float-end px-0 mt-4 mt-lg-2">
                    {/* <button className="btn btn-danger mx-2 px-3 float-end" type="button">PDF</button> */}
                    {
                        isExcelLoading ?
                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                <i
                                    className="fa fa-refresh fa-spin"
                                    style={{ marginRight: "5px" }}
                                />Loading</button>
                            :
                            ExcelData && ExcelData.table && ExcelData.table.length > 0 &&
                            <ExportStudentData
                                ExcelData={ExcelData}
                                name={paramName}
                            />
                    }
                </div>

                <div className="col-12">

                    <div className="shadows bg-white row rounded p-3 table_responsive" >

                        {/* <div className="mb-3 col-lg-1">
                            <label for="Name" className="form-label mt-1" style={{ whiteSpace: 'nowrap' }}>Student Name :</label>
                        </div>

                        <div className="mb-3 col-lg-5 px-0" style={{ marginLeft: '2%' }}>
                            <CommanDDL />
                        </div> */}

                        <table id="customers" >
                            <tr>
                                <th>Sr. No.</th>
                                <th>Student Name</th>
                                <th>Age (Year)</th>
                                <th>Contact Number</th>
                                <th>Email ID</th>
                                <th>Employement</th>
                                <th>Name Of Organization</th>
                                <th>Reason</th>
                                <th>Batch</th>
                                <th>Exam Fees (Rs.)</th>
                                <th>Receipt</th>
                            </tr>

                            {
                                TableData && TableData?.table?.length > 0 ? TableData?.table?.map((i, j) => {
                                    return (
                                        <tr>
                                            <td align="center">{i?.rowNum}</td>
                                            <td align="left" className="text-capitalize">{i?.fullName}</td>
                                            <td align="center">{i?.age}</td>
                                            <td align="center">{i?.contactNumber}</td>
                                            <td align="center">{i?.email || '-'}</td>
                                            <td align="center" className="text-capitalize">{i?.category_M_Indicator}</td>
                                            <td align="left" className="text-capitalize">{i?.name_Of_Organization || '-'}</td>
                                            <td align="left" className="text-capitalize">{i?.examinationPurpose}</td>
                                            <td align="center" className="text-capitalize">
                                                {
                                                    i?.week_Category_M_IndicatorID == 22 ?
                                                        <>
                                                            <span>Weekday</span><p className="mb-0">(Monday/Wednesday/Friday)</p>
                                                        </>
                                                        :
                                                        i?.week_Category_M_IndicatorID == 23 ?
                                                            <>
                                                                <span>Week Off</span><p className="mb-0">(Friday/Saturday)</p>
                                                            </>
                                                            :
                                                            i?.week_Category_M_IndicatorID == 24 ?
                                                                <>
                                                                    <span>Midweek</span><p className="mb-0">(Tuesday/Thursday/Friday)</p>
                                                                </>
                                                                :
                                                                ""

                                                }

                                            </td>
                                            <td align="right">&#8377; {i?.paidExamFee ? i?.paidExamFee.toFixed(2) : '0'}</td>
                                            <td align="center">
                                                {
                                                    (i?.uploadReceipt && i?.uploadReceipt != '') ?
                                                        <span style={{ cursor: 'pointer' }}
                                                            onClick={() => window.open(i?.uploadReceipt)}>
                                                            <File color="red" size={18} />
                                                        </span>
                                                        : '-'
                                                }
                                            </td>
                                        </tr>
                                    )
                                })
                                    :
                                    <tr>
                                        <td colSpan={9}>No Data Found ...</td>
                                    </tr>
                            }


                        </table>

                        <div className="col-12 pt-3 px-0">
                            {TableData && TableData?.table && TableData?.table?.length > 0 &&
                                <Pegination
                                    PerPageCount={PerPageCount}
                                    TotalCount={TableData?.table[0].totalCount}
                                    setFrom={setFrom}
                                    setTo={setTo}
                                    setrowNo={setrowNo}
                                    CurrentPage={CurrentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            }
                        </div>

                    </div>
                </div>

            </div>
        </>
    )
}